export const createText = ({
  text,
  left,
  top,
  fontSize,
  fontFamily,
  color = '#000000',
  fontWeight = 'normal',
  fontStyle = 'normal',
  textDecoration = 'none',
  align = 'center',
  width = 400
}) => ({
  type: 'text',
  text,
  left: `${left}px`,
  top: `${top}px`,
  fontSize: `${fontSize}px`,
  fontFamily,
  color,
  fontWeight,
  fontStyle,
  textDecoration,
  textAlign: align,
  width: `${width}px`
});

export const createLine = ({ left, top, width, thickness = 1, color = '#4c4b4d' }) => ({
  type: 'line',
  left: `${left}px`,
  top: `${top}px`,
  width: `${width}px`,
  thickness: `${thickness}px`,
  color
});

export const createImage = (src, left, top, width, height) => ({
  type: 'image',
  src,
  left: `${left}px`,
  top: `${top}px`,
  width: `${width}px`,
  height: `${height}px`
});
